/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
import { useTable } from "@/hooks/useTable";
import { ListFooter } from "@/components/shared/list-footer";

import { ErrorBoundary } from "react-error-boundary";
import { RecordNotFound } from "@/components/shared/record-not-found";
import { TableColumnsHandle } from "@/components/shared/table-columns-handle";
import { Columns3Icon, Download, FilterIcon, X } from "lucide-react";
import { useMutations } from "./utils/react-hook/use-mutations";
import { ReactTable, ReactTableSkelton } from "./utils";
import { Fragment } from "react/jsx-runtime";
import ErrorFallback from "@/components/shared/error-fallback";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { RangeDateSelector } from "@/components/form-input/range-date-selector";
import { MultiSelectWithSearchV3 } from "@/components/form-input/multi-select-with-search-v3";
import { useMemo } from "react";

export const CashBalanceReport = () => {
  const {
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    skeltonLoading,
    tableColumn,
    setTableColumn,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    onDateChange,
    allRetailerList,
    onRetailerSelect,
    isAdmin,
    selectedRecord,
    currentUser,
    currentCompanyData,
    downloadReport,
  } = useMutations();

  const allkeys = useMemo(() => {
    try {
      return Object.keys(listData[0]);
    } catch (error) {
      return [];
    }
  }, [listData]);

  const {
    tableHeader,
    table,
    tableKeys,
    // toggleSelection,
    // rowSelection,
    onResize,
    onSorting,
    // loading,
  } = useTable({
    data: listData,
    view: allkeys,
    verifyKey: "cash_balance_report",
    visible: tableColumn,
    avoid: [""],
  });

  const support_multi_doc_type =
    currentCompanyData?.settings?.support_multi_doc_type;

  return (
    <Fragment>
      <div className="flex flex-col gap-5">
        <ListPageTopBar title="Cash Balance Report">
          <RangeDateSelector onChange={onDateChange} />
          {support_multi_doc_type ? (
            <div className="flex gap-3">
              <div className="w-[239px]">
                <MultiSelectWithSearchV3
                  options={allRetailerList}
                  bindValue="retailer_id"
                  bindLabel="retailer_name"
                  placeholder="All Retailer"
                  onChange={(prop: any) => onRetailerSelect(prop)}
                  value={
                    isAdmin ? selectedRecord : [currentUser?.linked_customer]
                  }
                  disabled={!isAdmin}
                />
              </div>
              <Button
                variant={"action"}
                disabled={allRetailerList.length === 0}
                onClick={downloadReport}
                className="w-[220px]"
              >
                <Download /> Cash Balance Report
              </Button>
            </div>
          ) : null}
          <TableColumnsHandle
            tableKeys={tableKeys}
            tableColumn={tableColumn}
            setTableColumn={setTableColumn}
            onSorting={onSorting}
            labels={{
              user_name: "User Name",
              activity: "Activity",
              error_message: "Error Message",
              cts: "Date",
              status: "Status",
              // modified_by: "Modified By",
            }}
          >
            <Columns3Icon /> Column
          </TableColumnsHandle>

          <ConditionRenderer condition={Object.keys(filter).length !== 0}>
            <>
              <Button variant={"action"} onClick={filterRequest}>
                <FilterIcon /> Filter
              </Button>
              <Button variant={"action"} onClick={clearFilter}>
                <X /> Clear Filter
              </Button>
            </>
          </ConditionRenderer>

          {/* <Button variant={"action"} onClick={() => onFormOpenChange(true)}>
              + Create
            </Button> */}
        </ListPageTopBar>

        {skeltonLoading ? (
          <ReactTableSkelton />
        ) : (
          <Card className="overflow-hidden">
            <CardContent className="max-w-[100%] p-0 overflow-auto scrollbar h-auto min-h-[350px] md:h-[calc(100dvh-340px)]">
              <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => (
                  <ErrorFallback
                    error={error}
                    errorInfo={error.stack || ""}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
              >
                <ReactTable
                  tableHeader={tableHeader}
                  onResize={onResize}
                  table={table}
                  permission={permission}
                  onAction={onAction}
                  filter={filter}
                  setFilter={setFilter}
                  listData={listData}
                  filterRequest={filterRequest}
                />
                {table.length === 0 ? <RecordNotFound /> : null}
              </ErrorBoundary>
            </CardContent>
            <ErrorBoundary
              fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorFallback
                  error={error}
                  errorInfo={error.stack || ""}
                  resetErrorBoundary={resetErrorBoundary}
                />
              )}
            >
              <hr />
              <ListFooter
                onPageChange={onPageChange}
                onPerPageChange={onPerPageChange}
                page={paginationData.page}
                perPage={paginationData.perPage}
                totalItem={paginationData.totalItem}
                className="px-5 py-5"
                isEmpty={table.length === 0}
              />
            </ErrorBoundary>
          </Card>
        )}
      </div>
    </Fragment>
  );
};
